import React from "react";

import removeAccents from "../../../services/removeAccents";
import swal from 'sweetalert';


function SubscribersTemplate(props) {
    const
        [isLoading, setLoadingStatus] = React.useState(false),
        {subscribersTemplate = []} = props.event;

    const onAdd = (e)=>{
        e.preventDefault();

        if (props.maxCustomFields > subscribersTemplate.length){
            const { name, type } = e.target.elements;
    
            setLoadingStatus(true);
            subscribersTemplate.push({
                name: name.value,
                index: removeAccents(name.value).replace(/-/gi, '_'),
                type: type.value
            });
    
            props.firebase.updateById('events', props.event.id, { subscribersTemplate })
            .then(()=>{
                setLoadingStatus(false);
                name.value = "";
            })
            .catch(()=>{
                setLoadingStatus(false);
            });
        }
    }

    const onDelete = (index)=>{
        swal({
            title: "",
            text: "Se eliminará este campo, ¿Estas seguro?",
            icon: "warning",
            buttons: true,
            dangerMode: true
        })
            .then((willDelete) => {
                if (willDelete) {
                    setLoadingStatus(true);
                    subscribersTemplate.splice(index, 1);
                    props.firebase.updateById('events', props.event.id, { subscribersTemplate })
                        .then(() => {
                            setLoadingStatus(false);
                        })
                        .catch(() => {
                            setLoadingStatus(false);
                        });

                }
            });
        
    }
    return (
        <div className="row row-sm subscribers-loader full-width">
            <div>
                <button
                    className="btn btn-az-primary"
                    style={{ position: "absolute", left: "4px" }}
                    onClick={(e) => { props.handleTemplate() }}>
                    <i className="fas fa-arrow-left"></i> Volver</button>

                <h3>Plantilla para creación de Suscriptores</h3>
                <p>Los campos Nombre, Email y Contraseña serán obligatorios para todos los usuarios</p>

                <h6>Campos creados:</h6>
                <div className="template-container table-responsive">
                    <table className="table table-hover mg-t-20">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Nombre</th>
                                <th>Tipo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {subscribersTemplate.map((record, index)=>{
                                return (
                                    <tr key={`${record.index}_${index}`}>
                                        <td>
                                            <button
                                                onClick={(e)=>{onDelete(index)}}
                                                title={"Eliminar"}
                                                className="btnIcon"
                                                style={{ color: "red" }}>
                                                <i className="fas fa-times"></i>
                                            </button>
                                        </td>
                                        <td>{record.name}</td>
                                        <td>{record.type}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                
            </div>

            <div className="content-center">
                <h4>Crear campo</h4>
                <form onSubmit={onAdd}>
                    <FormControl title="Nombre">
                        <input className="form-control" name="name" />
                    </FormControl>
                    <FormControl title="Tipo">
                        <select className="form-control" name="type">
                            <option value="text">Texto</option>
                            <option value="number">Número</option>
                            <option value="date">fecha</option>
                        </select>
                    </FormControl>
                    {(subscribersTemplate.length < props.maxCustomFields) && (
                        <button disabled={isLoading} type="submit" className="btn btn-az-primary btn-block" role="menuitem"><i className={"fas fa-" + (isLoading ? "spinner fa-spin" : "save")} /> Guardar</button>
                    )}
                    {(subscribersTemplate.length >= props.maxCustomFields ) && (
                        <h5>Haz alcanzado el límite de campos que te permite agregar tu plan</h5>
                    )}
                </form>
            </div>
        </div>
    )
        }
        
        export default SubscribersTemplate;
        
const FormControl = ({title = "", children = null, isVisible = true}) => {
    return (
        <div className={(isVisible ? "row row-xs align-items-center mg-b-20" : 'hide')}>
                <div className="col-md-4">
                    <label className="form-label mg-b-0">{title}</label>
                </div>
                <div className="col-md-8 mg-t-5 mg-md-t-0">
                    {children}
                </div>
            </div>
            )
}